import CommonError from '../Common/CommonError'

const Error403Container = () => {
  return (
    <CommonError color="primary" src="3" />
  )
}

export default Error403Container